import { render, staticRenderFns } from "./CustomEntitiesMenuSelector.vue?vue&type=template&id=cafcb71e&scoped=true"
import script from "./CustomEntitiesMenuSelector.vue?vue&type=script&lang=js"
export * from "./CustomEntitiesMenuSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafcb71e",
  null
  
)

export default component.exports